/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */const r={fromAttribute(t){return t??""},toAttribute(t){return t||null}};export{r as stringConverter};
